<template>
    <header class="header">
        <div class="header__left">
            <a href="https://www.ubs.com/"><SvgIcon type="icon_ubs_logo" class="header__logo" alt="UBS-Logo"/></a>
            <a :href="$t('header:landingPageUrl')">
              <h1 class="header__title">
              {{ $t('header:title') }}
              </h1>
            </a>
        </div>
        <div class="header__right">
            <div class="header__content">
                <button
                    class="btn btn--text"
                    @click="openContactForm = !openContactForm"
                    @keyup.enter="openContactForm = !openContactForm"
                    >
                <SvgIcon type="icon_contact" class="contact__icon" alt="Contact-Form"/>
                <span class="contact__text">
                {{ $t('header:contact-form') }}
                </span>
                </button>
                <Modal
                    name="contact-us"
                    class="modal-layout-override contact-us-modal personal-info"
                    :open="openContactForm"
                    @close="openContactForm = false"
                    >
                    <template #header>
                        <span class="personal-info__heading">{{
                        $t("contactUs:clientInformation.heading")
                        }}</span>
                    </template>
                    <template #content>
                        <ContactUs @close="openContactForm = false"/>
                    </template>
                </Modal>
            </div>
        </div>
    </header>
</template>
<script>
import Modal from '@/components/layout/Modal'
import ContactUs from '@/views/Contact-Us'
import SvgIcon from '@/components/SvgIcon'

export default {
    name: 'Header',
    components: {
        Modal,
        ContactUs,
        SvgIcon
    },
    data() {
        return {
            openContactForm: false
        }
    }
}
</script>
